import { compareAsc, compareDesc, format, isDate, parseISO } from "date-fns";

// YYYY-MM-DD
export function formatDate(d: string | Date) {
  if (!d) {
    return;
  }
  let date = d;
  if (!isDate(date)) {
    if (typeof date === "string") {
      date = parseISO(date);
    }
  }
  return format(date as Date, "yyyy-MM-dd");
}

// YYYY-MM-DD HH:mm AM
export function formatDateTime(dt: string | Date | undefined) {
  if (!dt) {
    return;
  }
  let date = dt;
  if (!isDate(date)) {
    if (typeof date === "string") {
      date = parseISO(date);
    }
  }
  return format(date as Date, "yyyy-MM-dd hh:mm a");
}

// MM/DD/YY
export function formatShortDate(d: string | Date | undefined) {
  if (!d) {
    return;
  }
  let date = d;
  if (!isDate(date)) {
    if (typeof date === "string") {
      date = parseISO(date);
    }
  }
  return format(date as Date, "MM/dd/yy");
}

// MM/DD/YYYY
export function formatShortDateYYYY(d: string | Date | number) {
  if (!d) {
    return;
  }
  let date = d;
  if (!isDate(date)) {
    if (typeof date === "string") {
      date = parseISO(date);
    }
  }
  return format(date as Date, "MM/dd/yyyy");
}

// YYYY
export function formatYear(d: string | Date) {
  if (!d) {
    return;
  }
  let date = d;
  if (!isDate(date)) {
    if (typeof date === "string") {
      date = parseISO(date);
    }
  }
  return format(date as Date, "yyyy");
}

export function formatWithMonthName(d: string | Date) {
  if (!d) {
    return;
  }
  let date = d;
  if (!isDate(date)) {
    if (typeof date === "string") {
      date = parseISO(date);
    }
  }
  return format(date as Date, "MMM. do, yyyy");
}

export function sortDatesAsc(a: string | Date, b: string | Date) {
  try {
    let A = a;
    if (!isDate(A)) {
      if (typeof A === "string") {
        A = parseISO(A as string);
      }
    }
    let B = b;
    if (!isDate(B)) {
      if (typeof B === "string") {
        B = parseISO(B as string);
      }
    }
    return compareAsc(A as Date, B as Date);
  } catch (error) {
    return 0;
  }
}

export function sortDatesDesc(a: string | Date, b: string | Date) {
  try {
    let A = a;
    if (!isDate(A)) {
      if (typeof A === "string") {
        A = parseISO(A as string);
      }
    }
    let B = b;
    if (!isDate(B)) {
      if (typeof B === "string") {
        B = parseISO(B as string);
      }
    }
    return compareDesc(A as Date, B as Date);
  } catch (error) {
    return 0;
  }
}
